import getCooboId from "@/utils/getCooboId.js";
import getVimeoLink from "@/utils/getVimeoLink.js";
import getVimeoId from "@/utils/getVimeoId.js";

const iframe3DUrl = (id, locale) => `https://blob-jiocdn.embibe.com/coobo/teach_lite_3d_viewer_test/lite.html?id=asset-${id}&locale=${locale}`
const iframeSimulationUrl = (id, locale) => `https://school.embibe.com/teach/simulation/${id}?locale=${locale}`
const iframeLessonUrl = (id) => `https://school.embibe.com/create/view?id=${id}&respect-video-controls=true&delete_marginal_slides=true`

export default async function getLtiPreviewSrc(asset, token, locale = "en") {
  const assetType = asset.asset_type;
  let src = "";
  let srtUrl = "";
  try {
    switch (assetType) {
      case "3D": {
        src = iframe3DUrl(asset.variants_data.coobo_library_link.split('/').pop(), locale)
        break;
      }
      case "coobos":
      case "activities": {
        src = iframeLessonUrl(getCooboId(asset))
        break;
      }
      case "simulations": {
        src = iframeSimulationUrl(asset.id, asset.currentLocale)
        break;
      }
      case "videos": {
        const {vimeoId, srtUrl: _srtUrl} = await getVimeoId(asset, locale);
        srtUrl = _srtUrl;
        src = await getVimeoLink(vimeoId, token);
        break;
      }
      case "image":
      case "illustration":
      case "animation": {
        src = asset.variants_data.ready_links[0].url;
        break;
      }
      default: {
        break;
      }
    }
  } catch (err) {
    console.error(err)
  }
  return {src, srtUrl};
}
